import { getCommentary, getMatchStats } from '$utils/data';

import { dateSlug } from '$utils/dates';
import slugify from '$utils/slugify';

export async function load({ fetch, params, parent }) {
  const { data } = await parent();

  const slugPath = params.slugpath.split('-');
  const countrySlugs = slugPath.slice(0, -2).join('-');
  const month = slugPath.slice(-2)[0];
  const day = slugPath.slice(-1)[0];

  const matchData = data.matches.matches.match.filter((match) => {
    const contestants = match.matchInfo.contestant;
    if (contestants === null || contestants.length !== 2) return false;

    // Check dates match
    if (dateSlug(match?.matchInfo).trim() !== `${month}-${day}`.trim()) {
      return false;
    }

    // Check teams match
    const slugs = contestants.map((x) => slugify(x.name));
    return (
      slugs[0] !== slugs[1] &&
      countrySlugs.includes(slugs[0]) &&
      countrySlugs.includes(slugs[1])
    );
  });

  if (matchData.length !== 1) {
    return {
      data,
      commentary: null,
      match: null,
      matchId: null,
      matchStats: null,
    };
  }

  const match = matchData[0];
  const matchId = match.matchInfo.id;

  let matchStats = null;
  let commentary = null;
  if (match.liveData.matchDetails.matchStatus !== 'Fixture') {
    try {
      matchStats = await getMatchStats({ fetch, matchId });
    } catch (e) {}

    try {
      commentary = await getCommentary({ fetch, matchId });
    } catch (e) {}
  }

  return {
    data,
    commentary,
    match,
    matchId,
    matchStats,
  };
}
